import { Button, Container, Text, Title } from "@mantine/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import colors from "../../../utils/styles";

const BookingCheckIn = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams.entries());

  return <Container size="responsive"
    styles={{
      root: {
        background: 'linear-gradient(180deg,#67bae7,#32549b 33%,#32549b 66%,#67bae7)',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }
    }}>
    <div style={{
      borderRadius: '10px',
      border: colors.appBorder,
      padding: '40px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <Title style={{
        fontWeight: 900,
        color: colors.appYellow,
        textAlign: 'center',
        fontSize: '28px',
        marginBottom: 'md',
      }}>Check-In Success!
      </Title>
      {params.bookingId && <Text styles={{
        root: {
          fontSize: '18px',
          color: colors.appWhite,
          textAlign: 'center',
        }
      }}>
        <Text>Booking ID: <span style={{ fontWeight: 700, color: colors.appYellow }}>{params.bookingId}</span></Text>
        <Text>Customer Name: <span style={{ fontWeight: 700, color: colors.appYellow }}>{params.customer_name}</span></Text>
        <Text>Customer Email: <span style={{ fontWeight: 700, color: colors.appYellow }}>{params.customer_email}</span></Text>
        <Text>Booked Seats: <span style={{ fontWeight: 700, color: colors.appYellow }}>{params.booked_adult_seats} adults</span></Text>
        <Text>Booked Children Seats: <span style={{ fontWeight: 700, color: colors.appYellow }}>{params.booked_children_seats} children</span> </Text>
        <Text>Total Seats: <span style={{ fontWeight: 700, color: colors.appYellow }}>{params.booked_total_seats} total</span> </Text>
        <Text>Booking Type: <span style={{ fontWeight: 700, color: colors.appYellow }}>{params.booking_type.toUpperCase()}</span> </Text>
      </Text>}
      <Button
        style={{ backgroundColor: colors.appPink, boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.5)' }}
        onClick={() => navigate('/')} radius="xl" size="md" mt="xl">
        Back to home page
      </Button>
    </div>

  </Container>;
};

export default BookingCheckIn;
